/**
 * TabEmptyState Component
 * Shared empty state view for tab content areas.
 * Renders a heading, description, and optional CTA button.
 */

import { useNavigate } from "react-router-dom"

interface TabEmptyStateProps {
  title: string
  description: string
  ctaLabel?: string
  ctaTo?: string
}

export function TabEmptyState({ title, description, ctaLabel, ctaTo }: TabEmptyStateProps) {
  const navigate = useNavigate()

  return (
    <div className="pt-8">
      <h3 className="text-sm md:text-[18px] font-semibold leading-[30px] uppercase text-text-primary">
        {title}
      </h3>
      <p className="text-sm text-primary opacity-90 mt-2.5 leading-relaxed">{description}</p>
      {ctaLabel && ctaTo && (
        <button
          type="button"
          className="mt-5 h-[50px] w-full md:w-[280px] rounded-full bg-text-primary text-my-rituality-bg text-[14px] font-semibold uppercase cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => navigate(ctaTo)}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  )
}
